<template>
<div class="input-group">
  <input type="text" @input="keywordsInput" :placeholder="placeholder" :value="value" @keydown.enter="goSearch">
  <div v-if="showClear" @click.stop="clearText" class="iconfont icon-guanbi3"></div>
</div>
</template>

<script>
export default {
  name: "Input",
  data(){
    return{
      keywords:'',
      showClear:false
    }
  },
  props:{
    placeholder:'',
    value: {
      type: String,
      default: "",
    },
  },
  methods:{
    keywordsInput(e){
      this.$emit('input',e.target.value)
      if(e.target.value.trim() != '') this.showClear = true
      else this.showClear = false
    },
    goSearch(){
      this.$emit('enter')
    },
    clearText(){
      this.showClear = false
      this.$emit('input','')
      this.$emit('enter')
    }
  }
}
</script>

<style scoped>
.input-group{
  display: flex;
  width: 100%;
  align-items: center;
  padding:0 !important;
  position: relative;
}
.input-group input{
  flex: 1;
  padding: 0 !important;
  background: transparent;
}
.input-group input::placeholder{
  color: rgba(60,60,67,0.3);
}
.input-group div{
  cursor: pointer;
  color: #8F8F8F;
  position: absolute;
  right: 0;
  padding: 0 !important;
}
</style>
